<div class="input-group mb-3">
  <input [(ngModel)]="filtro" (keydown.enter)="onClick()" type="text" class="form-control"
    placeholder="Informe o que deseja localizar" aria-label="Informe o que deseja localizar"
    aria-describedby="button-addon2">
  <div class="input-group-append" style="height: 36px;">
    <button class="btn btn-outline-secondary" (click)="onClick()" type="button" id="button-addon2">
      <img src="assets/img/global/zoom.png" alt="localizar" height="20" width="20">
    </button>
  </div>
</div>
